import React, {Component} from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import momentDF from 'moment-duration-format';


class RealTime extends Component {
    static propTypes = {
        value: PropTypes.object,
        format: PropTypes.string,
        options: PropTypes.object,
        fromNow: PropTypes.bool,
        refresh: PropTypes.number,
    };

    static defaultProps = {
        format: "m",
        options: {},
        refresh: 1000,
    };

    constructor(props) {
        super(props);

        const value = moment.isMoment(props.value) ? props.value : moment(props.value, "X");

        this.state = {
            time: moment(),
            value: value,
            timeString: value.format("YYYY-MM-DDTHH:mm:ss"),
        };
    }

    componentDidMount() {
        this.timer = setInterval(() => {
            this.setState({
                time: moment(),
            });
        }, this.props.refresh);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            const value = moment.isMoment(this.props.value) ? props.value : moment(this.props.value, "X");

            this.setState({
                value: value,
                timeString: value.format("YYYY-MM-DDTHH:mm:ss"),
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    renderTime = () => {
        const {time, timeString, value} = this.state;
        const {format, options} = this.props;

        let display = "";

        if (this.props.fromNow) {
            display = value.fromNow();
        } else {
            const diff = time.diff(value);
            const duration = moment.duration(diff);
            const {hours, minutes, seconds} = duration._data;

            if (value.isBefore()) {
                return null;
            }

            const remainingMinutes = Math.abs(hours) * 60 + Math.abs(minutes);

            if (remainingMinutes < 1) {
                display = (seconds > -30) ? "kohe" : "< 1 min";
            } else if (remainingMinutes < 89) {
                const formattedDuration = Math.abs(parseInt(duration.format("m", options), 10));
                display = `${formattedDuration} min`;
            } else {
                display = value.format("H:mm");
            }
        }

        return (<time dateTime={timeString} title={value.format("HH:mm")}>{display}</time>);
    };

    renderChildren = () => {
        const {time, timeString} = this.state;

        const children = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                time,
                timeString,
            })
        );

        return (
            <div>{children}</div>
        )
    };

    render() {
        const hasChildren = React.Children.count(this.props.children) > 0;
        return hasChildren ? this.renderChildren() : this.renderTime();
    }
}

export default RealTime;



// WEBPACK FOOTER //
// ./src/components/RealTime.js